class PrintDepositPackingController {
    /*@ngInject*/
    constructor($state, $stateParams, AtmResidualDepositService, $q) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.manifestData = "";
        this.setupFromLocation = "";
        this.toLocation = "";
        this.carrier = "";
        this.totalDenomAmount = 0;
        this.AtmResidualDepositService = AtmResidualDepositService;
        this.$q = $q;
        this.contents = [];
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 5000,
            maxPages: 10
        }
    }

    $onInit() {
        let printData = undefined;
        this.date = new Date();

        if (window.opener && window.opener.w && window.opener.w.printData) {
            printData = window.opener.w.printData
            this.manifestData = printData.data;
            this.setupFromLocation = printData.setupFromLocation;
            this.toLocation = printData.toLocation;
            this.carrier = printData.carrier;
            this.currencySymbol = printData.currencySymbol || '$';
            this.loading = true;

            if (this.manifestData.account === 'regular' && this.toLocation.residualDeposit) {
                const defer = this.$q.defer();
                this.AtmResidualDepositService.contents(this.manifestData.id, this.pagination.pageLimit, (this.pagination.page - 1) * this.pagination.pageLimit)
                    .then((res) => {
                        this.contents = res;
                        this.contents.records.forEach((data) => {
                            this.totalDenomAmount += data.amount
                        })
                        defer.resolve(res)
                    })
                    .catch((err) => {
                        console.log(err);
                        defer.reject(err)
                    })
                    .finally(() => {
                        this.loading = false;
                    })
                return defer.promise.then((data) => {
                    setTimeout(() => {
                        window.print()
                    }, 1000)
                })
            }
            else {
                this.loading = false;
                setTimeout(() => {
                    window.print()
                }, 1000)
            }
        }

        if (this.manifestData && this.manifestData.account === 'emergency' && this.manifestData.printEmergencyPackData) {
            this.pendingPackLoader = true;
            this.AtmResidualDepositService.getPendingRelease(this.manifestData.branchId, this.toLocation.Value, this.manifestData.currency,
                this.manifestData.account, this.carrier ? this.carrier.Value : null, this.pagination.pageLimit, (this.pagination.page - 1) * this.pagination.pageLimit)
                .then((data) => {
                    this.pendingReleaseData = data;
                    this.totalDenomAmount = data.totalPendingRelease;
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    this.pendingPackLoader = false;
                })
        }

        // setTimeout(() => {
        //     window.print()
        // }, 1000)
    }
}

export default PrintDepositPackingController;


// WEBPACK FOOTER //
// ./client/app/components/deposit_packing/print/print_deposit_packing.controller.js